import { render } from "./VartaMenu.vue?vue&type=template&id=6be7d9aa&scoped=true"
import script from "./VartaMenu.vue?vue&type=script&lang=js"
export * from "./VartaMenu.vue?vue&type=script&lang=js"

import "./VartaMenu.vue?vue&type=style&index=0&id=6be7d9aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be7d9aa"]])

export default __exports__